import { useNavigate } from 'react-router-dom';
import { useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import LoginForm from '../../components/forms/LoginForm';
import NetworkBackground from '../../components/NetworkBackground';
import Toast from '../../components/Toast';
import authService from '../../services/authService';
import styles from './LoginPage.module.css';

export default function AuthPage() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [toast, setToast] = useState(null);
  const [showResend, setShowResend] = useState(false);
  const [emailToResend, setEmailToResend] = useState('');
  const [resendDisabled, setResendDisabled] = useState(false);

  const handleResend = async () => {
    setResendDisabled(true);
    const result = await authService.resendVerification(emailToResend);

    if (result.success) {
      setToast({ message: result.message || 'Verification email resent.', type: 'success' });
      setShowResend(false);
    } else {
      setToast({ message: result.error || 'Failed to resend verification email.', type: 'error' });
    }

    setTimeout(() => setResendDisabled(false), 60000);
  };

  const handleLogin = async (credentials) => {
    const result = await authService.login(credentials);

    if (result.success) {
      await login(result.token);
      navigate('/dashboard');
    } else {
      setToast({ message: result.error || 'Incorrect email or password.', type: 'error' });
      if (result.code === 'UNVERIFIED') {
        setShowResend(true);
        setEmailToResend(credentials.email);
      } else {
        setShowResend(false);
      }
    }
  };

  return (
    <div className={styles.pageWrapper}>
      <NetworkBackground />
      <div className={styles.authContainer}>
        <LoginForm
          onLogin={handleLogin}
          showResend={showResend}
          onResend={handleResend}
          resendDisabled={resendDisabled}
        />
      </div>

      {toast && (
        <Toast
          message={toast.message}
          type={toast.type}
          onClose={() => setToast(null)}
        />
      )}
    </div>
  );
}
